import React from 'react';
import { Accordion, Form, InputGroup } from 'react-bootstrap';
import { PreferencesTabs, type PreferencesTabsType } from '../Preferences';
import type { TagTO } from '../../../../lib';
import ReactTooltip from 'react-tooltip';

interface TagSettingProps {
  allTags: TagTO[];
  onChangeTag: (name: string, value: boolean) => void;
  tagState: Record<string, boolean>;
  activeTab: PreferencesTabsType;
}

const TagsSetting = ({
  tagState,
  onChangeTag,
  allTags,
  activeTab,
}: TagSettingProps) => {
  return (
    <Accordion.Item eventKey={PreferencesTabs.TAGS}>
      <Accordion.Header>
        <span className="d-flex align-items-center font-weight-600 gap-3">
          Tags
        </span>
        {activeTab !== PreferencesTabs.TAGS ? (
          <i className="fa fa-plus" aria-hidden="true" />
        ) : (
          <i className="fa fa-minus" aria-hidden="true" />
        )}
      </Accordion.Header>
      <Accordion.Body>
        <div className="list-information-header">
          Unselect any tags not relevant for your patient information.
        </div>
        <Form className="list-information-options max-width-70 my-4 tags-container">
          {allTags?.map((tag: TagTO) => (
            <React.Fragment key={`preferences-tag-${tag.shortName}`}>
              <InputGroup className="mb-3 tag-item">
                <InputGroup.Checkbox
                  aria-label={`Hide ${tag.shortName} tag`}
                  name={`tag-${tag.id}`}
                  checked={!!tagState[`tag-${tag.id}`]}
                  onChange={(e) => onChangeTag(e.target.name, e.target.checked)}
                />
                <span
                  className="tagFullName"
                  data-for={`preferences-tag-${tag.id}`}
                  data-tip
                >
                  {tag.shortName}
                </span>
              </InputGroup>
              <ReactTooltip id={`preferences-tag-${tag.id}`} effect="solid">
                <div className="mb-1">{tag.tagName}</div>
              </ReactTooltip>
            </React.Fragment>
          ))}
        </Form>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default TagsSetting;
